import tableAppProviders from './tableAppProviders';

export default {
  title: 'V.T. Manual Providers',
  attributeName: 'appProvider',
  getURL: 'appId/appProviderPlay',
  createURL: 'appId/appProviderPlay',
  updateURL: 'appId/appProviderPlay',
  removeURL: 'appId/appProviderPlay',
  sessionParams: ['appId'],
  noArea: true,
  removeNameField:'name',
  removeText:'You are about to remove the V.T. Provider with name ##name##.',
  tableConfig: tableAppProviders,
  autoUpdate: true,
};
